import { Component, OnInit, OnDestroy } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { ModalController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-location-control',
  templateUrl: './location-control.component.html',
  styleUrls: ['./location-control.component.scss'],
})
export class LocationControlComponent implements OnInit, OnDestroy {
  didInit = false;
  locationError = false;

  constructor(
    private mdlctrl: ModalController,
    public locationServ: LocationService,
    private loadingCtrl: LoadingController,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    try {
      const permissions = await Geolocation.checkPermissions();

      if (permissions.location === 'granted') {
        // Konum izni zaten verilmiş, konumu almaya çalış
        await this.getLocation();
        // getLocation başarısız olursa locationError zaten set edilir
      } else {
        // İzin yoksa, kullanıcıdan izin istenecek
        this.locationError = false;
      }
    } catch (error) {
      // checkPermissions başarısız olursa hata göster
      console.error('Permission check failed:', error);
      this.locationError = true;
    } finally {
      // Her durumda didInit true olmalı ki popup açılabilsin
      this.didInit = true;
    }
  }

  ngOnDestroy() {
    this.locationError = false;
    this.didInit = false;
    this.locationServ.distance = null;
    this.locationServ.isInHotel = null;
  }

  async close() {
    await this.mdlctrl.dismiss(false);
  }

  async checkPerm() {
    const LoadingMessage = this.translate.instant(
      'locationModal:loadingMessage'
    );

    const loading = await this.loadingCtrl.create({
      message: LoadingMessage,
      spinner: 'circles',
    });

    await loading.present();

    try {
      // First request permission
      await this.locationServ.permission();

      // Then get the location
      const isInHotel = await this.locationServ.getLocation();

      // Dismiss the loading indicator
      await loading.dismiss();

      // Only dismiss the modal if we successfully determined location
      this.mdlctrl.dismiss(isInHotel);
    } catch (error) {
      console.error('Error in location permission flow:', error);
      await loading.dismiss();
      this.locationError = true;
    }
  }

  async getLocation() {
    const loadingMessage = this.translate.instant('locationModal:getLocationMessage');
    const loading = await this.loadingCtrl.create({
      message: loadingMessage,
      spinner: 'circles',
    });

    await loading.present();

    try {
      const isInHotel = await this.locationServ.getLocation();
      await loading.dismiss();

      if (isInHotel) {
        await this.mdlctrl.dismiss(true);
      }
    } catch (error) {
      console.error('Error getting location:', error);
      await loading.dismiss();
      this.locationError = true;
    }
  }
}
